import types from '../constants/types'

export const recordMutation = {
  [types.FETCH_RECORD_REQUEST] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isFetching'] = true
    state[action.request]['didInvalidate'] = false
  },
  [types.FETCH_RECORD_SUCCESS] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isFetching'] = false
    state[action.request]['didInvalidate'] = false
    state[action.request]['data'] = action.data.data || action.data.info
    state[action.request]['lastUpdated'] = (new Date()).getTime()
  },
  [types.FETCH_RECORD_FAILURE] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isFetching'] = false
    state[action.request]['didInvalidate'] = true
  },
  [types.FETCH_RECORD_INIT] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isFetching'] = false
    state[action.request]['didInvalidate'] = false
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/fetchrecord.js